import {createPlaque} from '/plaque/create_plaque.js';
import {quitPlaque} from '/plaque/quit_plaque_window.js';
import {makePlaqueQuitToggle} from '/plaque/quit_plaque_toggle.js';
import {API_GATEWAY} from '/constants/API_constants.js';
import {makeNewButton} from '/buttons_functions/custom_button_functions.js';
import { createLoadingScreen } from "/loading_screen_functions/loading_screen_functions.js";
import { insertPlaqueAndAlertWindow } from "/alert/alert_functions.js";
import { logOutWithTimeOut } from '/login/logout.js';
import { ParamValidator } from '/validation/param_validator.js';

const MAX_REPOST_LENGTH = 10000;

export function makeElementRepostButton(element, nodeId) {

    element.addEventListener('click', ()=> invokeRepostWindow(nodeId));

    element.makeColorInteractions = (backgroundColor, textColor, backgroundInteraction=null, textInteraction=null) =>
        makeColorInteractions(element, backgroundColor, textColor, backgroundInteraction, textInteraction);

    return element;
}

function invokeRepostWindow(nodeId) {
    const plaque = createPlaque();

    plaque.style.paddingTop = '140px';

    const createRepostWindow = document.createElement('div');
    createRepostWindow.setAttribute('id', 'create-repost-window');

    //const createRepostLabel = document.createElement('p');
    //createRepostLabel.innerText = 'Add a commentary to your repost'

    const createRepostText = document.createElement('textarea');
    createRepostText.placeholder = 'Add a commentary to your repost...';

    
    const repostButtonGroup = createRepostButtonGroup(nodeId, createRepostText, plaque);
    
    //createRepostWindow.append(createRepostLabel);
    createRepostWindow.append(createRepostText);
    createRepostWindow.append(repostButtonGroup);

    plaque.append(createRepostWindow);
}

function createRepostButtonGroup(nodeId, textInput, plaque) {

    const repostButtonGroup = document.createElement('div');
    const createRepostButton = document.createElement('button');
    const cancelRepost = document.createElement('button');

    makeNewButton(createRepostButton, 'light-black', 'white', 'Repost', 'lighten');
    createRepostButton.addEventListener('click', () => sendRepost(nodeId, textInput, plaque, repostButtonGroup));

    makeNewButton(cancelRepost, 'grey', 'black', 'Cancel', 'darken');
    cancelRepost.addEventListener('click', ()=> quitPlaque(
        plaque,
        'Are you sure you don\'t want to repost?',
        'Go back',
        'Quit'
    ));

    makePlaqueQuitToggle(plaque,
        'Are you sure you don\'t want to repost?',
        'Go back',
        'Quit'
    );

    repostButtonGroup.append(cancelRepost);
    repostButtonGroup.append(createRepostButton);

    return repostButtonGroup;

}

async function sendRepost(nodeId, textInput, plaque, buttonGroup) {

    const commentary = ParamValidator.basicSanitize(textInput.value);
    if(!ParamValidator.isSafeTextNullable(commentary, MAX_REPOST_LENGTH)) {
        insertPlaqueAndAlertWindow('Your repost commentary is either too long or contains inappropriate characters');
        return;
    }

    const loadingScreen = createLoadingScreen(50, 50, 100);
    buttonGroup.insertAdjacentElement('beforebegin', loadingScreen);
    buttonGroup.remove();


    const url = new URL(API_GATEWAY + 'posts/repost'); // <--- change
    url.searchParams.append('nodeId', nodeId);
    url.searchParams.append('commentary', commentary);
    
    
    const response = await fetch(url, {
        method : 'POST',
        headers : {
            'Token-Auth' : `${localStorage.branchof_access_token}`
        }
    });
    
    setTimeout(()=>{
        if(response.status===200) {
            plaque.remove();
        } else if(response.status===401) {
            const newButtonGroup = createRepostButtonGroup(nodeId, textInput, plaque);
            loadingScreen.insertAdjacentElement('beforebegin', newButtonGroup);
            loadingScreen.remove();
            
            insertPlaqueAndAlertWindow('Your login has expired');
            //logOutWithTimeOut();
        } else {
            const newButtonGroup = createRepostButtonGroup(nodeId, textInput, plaque);
            loadingScreen.insertAdjacentElement('beforebegin', newButtonGroup);
            loadingScreen.remove();
            
            insertPlaqueAndAlertWindow('Something went wrong');
        }
    }, 1000);

}

function makeColorInteractions(repostButton, backgroundColor, textColor, backgroundInteraction, textInteraction) {
    makeNewButton(repostButton, backgroundColor, textColor, null, backgroundInteraction, textInteraction);
}